var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 18a4 4 0 11-8 0 4 4 0 018 0zM14 6a4 4 0 11-8 0 4 4 0 018 0z",
    fill: "#ADC9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 19a1 1 0 100-2 1 1 0 000 2z",
    fill: "#105ED5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 22c1.48 0 2.773-.804 3.465-2H20a2 2 0 100-4h-2.535A3.998 3.998 0 0014 14c-1.48 0-2.773.804-3.465 2H4a2 2 0 100 4h6.535A3.998 3.998 0 0014 22zm0-1.25a2.75 2.75 0 100-5.5 2.75 2.75 0 000 5.5z",
    fill: "#105ED5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7a1 1 0 100-2 1 1 0 000 2z",
    fill: "#105ED5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10c1.48 0 2.773-.804 3.465-2H20a2 2 0 100-4h-6.535A3.998 3.998 0 0010 2c-1.48 0-2.773.804-3.465 2H4a2 2 0 100 4h2.535A3.998 3.998 0 0010 10zm0-1.25a2.75 2.75 0 100-5.5 2.75 2.75 0 000 5.5z",
    fill: "#105ED5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsActive);
export default __webpack_public_path__ + "static/media/settings-active.75cae566800f7390bcae433786e5de31.svg";
export { ForwardRef as ReactComponent };